import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4986b466"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-card-body" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "info-row" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "info-row" }
const _hoisted_7 = { class: "label" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "info-row" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "wallet-uri" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "info-row" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "qrcode-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QrCodeVue = _resolveComponent("QrCodeVue")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$gettext("Backend:")), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.recipient.internalId.split(":")[0]), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$gettext("Administrative backend id:")), 1),
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.recipient.id), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$gettext("Wallet URI:")), 1)
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.recipient.internalId), 1)
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$gettext("Wallet QR Code:")), 1)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(_component_QrCodeVue, {
        "render-as": "svg",
        value: 
          JSON.stringify({
            rp: _ctx.recipient.id,
            rpb: _ctx.recipient.internalId,
          })
        
      }, null, 8, ["value"])
    ])
  ]))
}